import nth from 'lodash/nth'
import type {
  MultipleQueriesResponse,
  SearchResponse,
} from '@algolia/client-search'
import type { SearchEngineEventItem } from '~/composables/types/searchEngine'

type AlgoliaResults = Ref<MultipleQueriesResponse<SearchEngineEventItem> | null>

export const eventSectionComposableFactory =
  (index: number) => (algoliaResults: AlgoliaResults) => {
    const queryId = ref()
    const data = ref()

    watchEffect(() => {
      const result = nth(algoliaResults.value?.results, index)

      queryId.value = (
        result as SearchResponse<SearchEngineEventItem> | undefined
      )?.queryID
      data.value =
        (result as SearchResponse<SearchEngineEventItem> | undefined)?.hits ||
        []
    })
    return {
      queryId,
      data,
    }
  }
